exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".imbee-bubble-close-cross[data-v-23da2404]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;box-sizing:border-box;user-select:none;padding:3px 8px;text-align:center;justify-content:center;align-items:center;font-family:Arial;line-height:1.2;position:absolute;border-radius:60%;-webkit-border-radius:60%;-moz-border-radius:60%;-ms-border-radius:60%;font-size:20px!important;-o-border-radius:60%;white-space:nowrap}.imbee-bubble-close-cross>span[data-v-23da2404],.imbee-bubble-close-cross[data-v-23da2404]{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-23da2404","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CloseCross.vue
// module id = 175
// module chunks = 0 1